class DeviceInfo {	// if user agent is not windows and not macintosh, then it is mobile

	static isMobile() {
		return (
      !/Windows NT/i.test(navigator.userAgent)
      && !/Macintosh/i.test(navigator.userAgent)
      //Chromebook
      && !/CrOS/i.test(navigator.userAgent)
    );
	}
	static getDeviceType() {
		// determine if a device is: desktop, mobile, tablet, or unknown
		// if user agent is not windows and not macintosh, then it is mobile
		let deviceType = 'unknown';
		if (/Windows NT/i.test(navigator.userAgent)) {
			deviceType = 'desktop';
		} else if (/Macintosh/i.test(navigator.userAgent)) {
			deviceType = 'desktop';
    } else if (/CrOS/i.test(navigator.userAgent)) {
			deviceType = 'desktop';
		} else if (/Android/i.test(navigator.userAgent)) {
			deviceType = 'mobile';
		} else if (/iPhone/i.test(navigator.userAgent)) {
			deviceType = 'mobile';
		} else if (/iPad/i.test(navigator.userAgent)) {
			deviceType = 'tablet';
		}
		return deviceType;
	}
	static getOS() {
		const userAgent = navigator.userAgent,
			platform = navigator.userAgentData?.platform || navigator.platform,
			macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
			windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
			iosPlatforms = ['iPhone', 'iPad', 'iPod'];
		let os = null;

		if (macosPlatforms.indexOf(platform) !== -1) {
			os = 'Mac OS';
		} else if (iosPlatforms.indexOf(platform) !== -1) {
			os = 'iOS';
		} else if (windowsPlatforms.indexOf(platform) !== -1) {
			os = 'Windows';
		} else if (/Android/.test(userAgent)) {
			os = 'Android';
		} else if (/Linux/.test(platform)) {
			os = 'Linux';
		} else {
			os = 'Unknown';
		}

		return os;
	}
}

export {
	DeviceInfo
}
